export default __webpack_public_path__ + "static/media/17.48654d71.jpg";